















import { Vue, Component, Prop } from "vue-property-decorator";
import CatalogueImportCable from "@/utils/CatalogueImportCable";
import CatalogueExportCable from "@/utils/CatalogueExportCable";

@Component({})
export default class OperationProgress extends Vue {
  @Prop({ default: "import" }) readonly operation!: string;
  handler = null;
  progress = 0;

  mounted() {
    this.initOperation();
  }

  initOperation() {
    if (this.handler) {
      this.handler.close();
    }
    this.handler =
      this.operation === "import"
        ? new CatalogueImportCable()
        : new CatalogueExportCable();
    this.handler.onResponse = this.handlerResult.bind(this);
    this.handler.open();
  }

  notifyEvent(event: string, payload) {
    this.$emit(event, payload);
  }

  async handlerResult(data) {
    await this.$nextTick();

    const { event, status, progress, result, error, errors } = data;
    if (event === `${this.operation}.completed`) {
      this.handler.close();
      this.progress = 100;
      this.notifyEvent("completed", progress);
    } else if (event === `${this.operation}.failed`) {
      this.handler.close();
      this.progress = 100;
      this.notifyEvent("failed", errors || error);
    } else if (event === `${this.operation}.progress`) {
      this.progress = Math.round(progress);
    }
  }
}
